import React, { useEffect } from 'react';
import { Col, Row } from 'antd';
import style from './index.scss';
import BreadCrumb from '../../../components/BreadCrumb';
import SegmentsListing from './segmentsListing';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import {
  getCustomerType,
  postCustomerType,
  putCustomerType,
  deleteCustomerType
} from '../../../redux/actions/ns/runInstance';
import Wait4Me from '../../../components/Wait4Me';

export const Segments = ({
  apiActions,
  customerTypeList,
  authentication,
  deleteCustomerTypeList
}) => {
  return (
    <Row>
      <Col span={24}>
        <div className={style.wrapper}>
          <div className={style.head}>
            <BreadCrumb crumbs={[{ label: 'Segments' }]} />
            <div className={style.head_content}>
              <h4>Segments</h4>
            </div>
          </div>
          {customerTypeList?.data?.length === 0 || undefined ? (
            <div className={style.loadingWrapper}>
              <Wait4Me />
            </div>
          ) : (
            <SegmentsListing
              apiActions={apiActions}
              authentication={authentication}
              customerTypeList={customerTypeList}
              deleteCustomerTypeList={deleteCustomerTypeList}
            />
          )}
        </div>
      </Col>
    </Row>
  );
};

function mapStateToProps(state, ownProps = {}) {
  return {
    customerTypeList: state.nsRunInstanceConfig.customerTypeList || {},
    authentication: state.authentication,
    deleteCustomerTypeList:
      state.nsRunInstanceConfig.deleteCustomerTypeList || {}
  };
}

function mapDispatchToProps(dispatch) {
  return {
    apiActions: bindActionCreators(
      {
        navigateTo: (path) => push(path),
        getCustomerType,
        postCustomerType,
        putCustomerType,
        deleteCustomerType,
        dispatch
      },
      dispatch
    ),
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Segments);
